













import { Tag, ThemeTreeItem } from "@/api/models";
import { notEmptyString } from "@/api/validators";
import { SiteState, SubmissionState } from "@/store/types";
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
import HelpWidget from "./HelpWidget.vue";

@Component({
  components: { HelpWidget },
})
export default class ThemeTree extends Vue {
  @Prop({ default: "Theme" }) label: string;
  @Prop({ default: "Sub-themes" }) subLabel: string;
  @State("site") site: SiteState;
  @State("submission") submission: SubmissionState;

  slug = "";

  subSlugs: string[] = [];

  showMaxMsg = false;

  created() {
    this.sync();
  }

  get themes() {
    return this.site.themes.map((item, index) => new ThemeTreeItem(item, index));
  }

  get hasTheme() {
    return notEmptyString(this.slug);
  }

  get maxMsg() {
    const sKey = ['submission', 'max_subthemes'].join('__');
    const snippet = this.site.snippets.find(sn => sn.key === sKey)
    if (snippet instanceof Object) {
      return snippet.value.replace(/\b\d+\b/, this.maxSubThemes.toString());
    } else {
      return `You may add a maximum of ${this.maxSubThemes} sub-themes. Click to deselect.`;
    }
  }

  get subThemes() {
    let tags: Tag[] = [];
    if (notEmptyString(this.slug)) {
      const par = this.site.themes.find(row => row.slug === this.slug);
      if (par instanceof Object) {
        const { children } = par;
        if (children instanceof Array) {
          tags = children.map((row, index) => new Tag(row, index));
        }
      }
    }
    return tags;
  }

  get showSubThemes(): boolean {
    return this.subThemes.length > 0;
  }

  get maxSubThemes() {
    const num = this.site.settings.get('max_subthemes');
    return typeof num === 'number' ? num : 3;
  }

  get subThemeLabel() {
    return this.subThemes.length > 0 ? this.subLabel : '';
  }

  sync() {
    const { themes, subthemes } = this.submission;
    if (themes.length > 0) {
      this.slug = themes[0].slug;
      if (subthemes.length > 0) {
        setTimeout(() => {
          this.subSlugs = subthemes.map(row => row.slug);
        }, 250)
      }
    }
  }

  syncTheme() {
    const par = this.site.themes.find(row => row.slug === this.slug);
    const hasTheme = par instanceof Object;
    const subthemes = hasTheme ? this.subThemes.filter(row => this.subSlugs.includes(row.slug)) : [];
    const themes =  hasTheme ? [new Tag(par)] : [];
    this.$emit('update', { themes, subthemes })
  }

  @Watch('slug')
  changeSlug() {
    setTimeout(() => {
      const allowedSlugs = this.subThemes.map(st => st.slug);
      this.subSlugs = this.subSlugs.filter(sl => allowedSlugs.includes(sl));
      this.syncTheme();
    }, 125);
  }

  @Watch('subSlugs')
  changeSubSlugs(newVals, oldVals) {
    if (newVals instanceof Array && oldVals instanceof Array && oldVals.length > 0 && newVals.length > oldVals.length && this.subSlugs.length > this.maxSubThemes) {
      const remIndex = newVals.findIndex(slug => oldVals.indexOf(slug) < 0);
      if (remIndex >= 0) {
        this.subSlugs.splice(remIndex,1);
      }
      this.showMaxMsg = true;
      setTimeout(() => {
        this.showMaxMsg = false;
      }, 10000)
    } else {
      this.syncTheme();
      if (newVals.length < this.maxSubThemes) {
        this.showMaxMsg = false;
      }
    }
  }

}
